import type { Clip, Job } from './types'

export function clipProcessingState(clip: Clip, jobs: Job[]) {
  const renders = jobs.filter((job) => job.clip_id === clip.id && job.kind === 'render')
  const active = renders.find((job) => job.status === 'running') || renders.find((job) => job.status === 'queued')
  if (active) return active.status === 'running' ? 'rendering' : 'queued'
  if (clip.status === 'failed') return 'failed'
  const latest = [...renders].sort((a, b) => b.created_at.localeCompare(a.created_at))[0]
  if (clip.status === 'rendering' && latest && ['failed', 'interrupted'].includes(latest.status)) return 'failed'
  return clip.status === 'rendering' ? 'preparing' : 'unavailable'
}
